// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3b7023c9","455":"8257a0ad","977":"0eda0cb9"}[chunkId] + ".chunk.js";
};